export default (sentinelNumber) => {
    const sentinelString = String(sentinelNumber);
    return sentinelString.substring(0, 2) + "-" + sentinelString.substring(2);
}